export type HamletOrderableItem = {
  readonly orderableItemId: string;
  readonly description: string;
  readonly amount: number;
  readonly renewalAmount: number;
  readonly licenseType: string;
  readonly unitCount: number;
  readonly monthsValid: number;
  readonly editionDescription: string;
  readonly editionId: string;
  readonly editionType: string;
  readonly starter: boolean;
  readonly saleType: string;
  readonly enterprise: boolean;
  readonly publiclyAvailable: boolean;

  readonly editionTypeIsDeprecated: boolean;
  readonly renewalFrequency: string;
  readonly unitLabel: string;

  readonly edition: unknown;
  readonly sku: unknown;
};
